import PlatformManagerOrganizationManagement from "../components/platformManagerOrganizationManagement.component";

/**
 * On this page, the platform manager can manage the organizations of the platform.
 * @returns
 */
export default function PlatformManagerOrganizationPage() {
	return (
		<div className="container mx-auto max-w-5xl p-4 sm:p-6">
			<h1 className="text-2xl font-semibold mb-4">Organisationen</h1>
			<PlatformManagerOrganizationManagement />
		</div>
	);
}
